import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement) => {
  function handleLinkClick(event: Event) {
    let el = event.target as HTMLElement;
    let isAnchorTag = el.tagName === 'A';
    let parentAnchorTag = el.closest('a');
    let anchor = isAnchorTag ? el : parentAnchorTag;

    if (anchor !== null) {
      event.preventDefault();

      let href = anchor.getAttribute('href');

      if (href !== null) {
        window.open(href, '_blank');
      }
    }
  }

  let elDocument = element instanceof HTMLIFrameElement ? element.contentDocument : element;

  elDocument?.addEventListener('click', handleLinkClick);

  return () => elDocument?.removeEventListener('click', handleLinkClick);
});
